import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "container"
};
var _hoisted_2 = {
  class: "content-class"
};
var _hoisted_3 = {
  class: "number-panel mrg16"
};
var _hoisted_4 = {
  class: "body mrg16"
};
var _hoisted_5 = {
  class: "body-item"
};
var _hoisted_6 = {
  class: "echart-title"
};
var _hoisted_7 = {
  key: 0,
  class: "flex-center"
};
var _hoisted_8 = {
  class: "body-item"
};
var _hoisted_9 = {
  class: "echart-title"
};
var _hoisted_10 = {
  key: 0,
  class: "flex-center"
};
var _hoisted_11 = {
  class: "body-item"
};
var _hoisted_12 = {
  class: "echart-title"
};
var _hoisted_13 = {
  key: 0,
  class: "flex-center"
};
var _hoisted_14 = {
  class: "teach-detail mrg16"
};
var _hoisted_15 = {
  key: 1,
  class: "empty-box"
};
import { getDirectorClassLessons, getDirectorPeriodLessons, getDirectorTeacherLessons, getDrectorDataSheet,
// getGradeDirector, // 获取年级数据
getSchoolList,
// 获取学校列表
getSchoolOrGrade, getTimeDirectorPeriod, getTimeTeacherPeriod // 获取时间周期
} from '@/api/index-guan';
import { ref, nextTick, reactive, computed, onMounted } from 'vue';
import FormItem from '../components/lib/FormItem';
import mTable from '../components/lib/Table';
import { TABLE_HEAD } from '../components//const/table';
import analysisTab from '../components/analysisTab.vue';
import overviewPanel from '../components/overviewPanel.vue';
import PageSearch from '../components/PageSearch.vue';
import teachTab from '../components/teachTab.vue';
import barAnalysis from '../echarts/barAnalysis';
import lineAnalysis from '../echarts/lineAnalysis';
import { getStore } from '@/util/store';
export default {
  __name: 'classTeacher',
  setup: function setup(__props) {
    var userInfo = getStore({
      name: 'userInfo'
    });
    var typeOptions = ref([{
      label: '月份',
      value: 1
    }, {
      label: '周',
      value: 0
    }]);
    var cycleType = ref(0);
    var schoolOptions = ref([]);
    var timesOptions = reactive({
      1: [],
      0: []
    });
    var gradeOptions = ref([]);
    var schoolId = ref('');
    var gradeId = ref('');
    var cycle = ref('');
    var type = ref('发起课堂数');
    var overviewRef = ref();
    var handleChange = function handleChange() {
      getAnalysisData();
      getRecotorData();
      nextTick(function () {
        overviewRef.value.getPanelOverview();
      });
    };
    var handleChangeSchool = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getGradeData();
            case 1:
              handleChange();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function handleChangeSchool() {
        return _ref.apply(this, arguments);
      };
    }();
    var emptyImage = require('@/assets/home/dataReport/images/empty-chart.png');
    var emptyAllImage = require('@/assets/home/dataReport/images/empty-icon.png');
    var states = reactive({
      allPeriodData: {},
      // 授课次数-学段
      allTeacherData: {},
      // 授课次数-教师
      allClassData: {},
      // 授课次数-班级
      periodData: {},
      // 授课次数-学段
      teacherData: {},
      // 授课次数-教师
      classData: {},
      // 授课次数-班级
      loading_period: true,
      loading_teacher: true,
      loading_class: true
    });
    var getAnalysisData = function getAnalysisData() {
      states.loading_period = true;
      states.loading_teacher = true;
      states.loading_class = true;
      var data = {
        schoolId: schoolId.value,
        // ,
        cycle: cycle.value,
        grade: gradeId.value,
        cycleType: cycleType.value
      };
      // 学段
      getDirectorPeriodLessons(data).then(function (res) {
        states.loading_period = false;
        var resData = res.data.data;
        states.allPeriodData = resData;
        states.periodData = dealGetNowSuitData(states.allPeriodData);
        // console.log(states.periodData)
      });

      // 教师的
      getDirectorTeacherLessons(data).then(function (res) {
        states.loading_teacher = false;
        var resData = res.data.data;
        states.allTeacherData = resData;
        states.teacherData = dealGetNowSuitData(states.allTeacherData);
        // console.log(states.teacherData)
      });
      // 班级
      getDirectorClassLessons(data).then(function (res) {
        states.loading_class = false;
        var resData = res.data.data;
        states.allClassData = resData;
        states.classData = dealGetNowSuitData(states.allClassData);
      });
    };
    var dealGetNowSuitData = function dealGetNowSuitData(searchData) {
      var reLegend = [];
      var reSeries = [];
      reLegend = searchData.legend.filter(function (item) {
        return item.indexOf(type.value) > -1;
      });
      reSeries = searchData.series.filter(function (item) {
        return item.name.indexOf(type.value) > -1;
      });
      return {
        legend: reLegend,
        series: reSeries,
        showTitle: false,
        isRate: type.value.indexOf('率') > -1,
        title: searchData.title,
        xaxis: searchData.xaxis
      };
    };
    // 切换类型
    var handleAnalyTab = function handleAnalyTab(val) {
      type.value = val.label;
      states.periodData = dealGetNowSuitData(states.allPeriodData);
      states.teacherData = dealGetNowSuitData(states.allTeacherData);
      states.classData = dealGetNowSuitData(states.allClassData);
    };
    // 学校名称
    var schoolName = computed(function () {
      var _schoolOptions$value$;
      return (_schoolOptions$value$ = schoolOptions.value.find(function (item) {
        return item.schoolId === schoolId.value;
      })) === null || _schoolOptions$value$ === void 0 ? void 0 : _schoolOptions$value$.schoolName;
    });
    var gradeName = computed(function () {
      var _gradeOptions$value$f;
      return (_gradeOptions$value$f = gradeOptions.value.find(function (item) {
        return item.id === gradeId.value;
      })) === null || _gradeOptions$value$f === void 0 ? void 0 : _gradeOptions$value$f.name;
    });
    var showPeriod = computed(function () {
      var series = states.periodData.series;
      if (!series) {
        return false;
      }
      var isNowNone = series.some(function (item) {
        var bool = false;
        if (item && item.data.length > 0) {
          bool = item.data.some(function (itm) {
            return itm > 0;
          });
        }
        return bool;
      });
      return isNowNone;
    });
    var showTeacher = computed(function () {
      var series = states.teacherData.series;
      if (!series) {
        return false;
      }
      var isNowNone = series.some(function (item) {
        var bool = false;
        if (item && item.data.length > 0) {
          bool = item.data.some(function (itm) {
            return itm > 0;
          });
        }
        return bool;
      });
      return isNowNone;
    });
    var showClass = computed(function () {
      var series = states.classData.series;
      if (!series) {
        return false;
      }
      var isNowNone = series.some(function (item) {
        var bool = false;
        if (item && item.data.length > 0) {
          bool = item.data.some(function (itm) {
            return itm > 0;
          });
        }
        return bool;
      });
      return isNowNone;
    });
    // 表格数据
    var columns = ref(TABLE_HEAD.noTablecolumn);
    var tdata = ref([]);
    var size = ref(20);
    var current = ref(1);
    var classType = ref('');
    var subject = ref('');
    var isUse = ref('');
    var total = ref(0);
    var getRecotorData = function getRecotorData() {
      var data = {
        classType: classType.value,
        grade: gradeId.value,
        subject: subject.value,
        isUse: isUse.value,
        size: size.value,
        current: current.value,
        schoolId: schoolId.value,
        cycle: cycle.value,
        cycleType: cycleType.value
      };
      getDrectorDataSheet(data).then(function (res) {
        tdata.value = res.data.data.records;
        total.value = res.data.data.total;
      });
    };
    // 切换有无，班级数据信息
    var handleChangeTab = function handleChangeTab(val) {
      // console.log(val)
      classType.value = val.classType;
      // gradeId.value = val.grade
      subject.value = val.subject;
      isUse.value = val.isUse ? 1 : 0;
      columns.value = val.isUse ? TABLE_HEAD.tablecolumn : TABLE_HEAD.noTablecolumn;
      getRecotorData();
    };
    var changePageSize = function changePageSize(num) {
      current.value = 1;
      size.value = num;
      getRecotorData();
    };
    var changeCurrent = function changeCurrent(num) {
      current.value = num;
      getRecotorData();
    };

    // 获取时间周期
    var getTimeDirectorPeriodData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getTimeDirectorPeriod(1).then(function (res) {
                if (res.data.data) {
                  timesOptions[1] = res.data.data.map(function (item) {
                    console.log(item);
                    return {
                      label: item,
                      value: item
                    };
                  });
                } else {
                  timesOptions[1] = [];
                }
              });
            case 1:
              _context2.n = 2;
              return getTimeDirectorPeriod(0).then(function (res) {
                if (res.data.data) {
                  timesOptions[0] = res.data.data.map(function (item) {
                    return {
                      label: item,
                      value: item
                    };
                  });
                  cycle.value = res.data.data[0];
                } else {
                  timesOptions[0] = [];
                }
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function getTimeDirectorPeriodData() {
        return _ref2.apply(this, arguments);
      };
    }();
    var handleChangeType = function handleChangeType() {
      cycle.value = timesOptions[cycleType.value][0].value;
      handleChange();
    };
    // 获取学校列表
    var getSchoolListData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return getSchoolList().then(function (res) {
                // console.log(res)
                schoolOptions.value = res.data.data || [];
                if (schoolOptions.value.length) {
                  schoolId.value = schoolOptions.value[0].schoolId;
                }
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function getSchoolListData() {
        return _ref3.apply(this, arguments);
      };
    }();
    // 获取年级趋势
    var getGradeData = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var gradeParam;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (schoolId.value) {
                _context4.n = 1;
                break;
              }
              gradeId.value = '';
              gradeOptions.value = [];
              return _context4.a(2);
            case 1:
              gradeParam = {
                deptId: schoolId.value,
                userId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id,
                type: 1
              };
              _context4.n = 2;
              return getSchoolOrGrade(gradeParam).then(function (res) {
                gradeOptions.value = res.data.data || [];
                if (gradeOptions.value.length) {
                  gradeId.value = gradeOptions.value[0].id;
                } else {
                  gradeId.value = '';
                }
              });
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function getGradeData() {
        return _ref4.apply(this, arguments);
      };
    }();
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _context5.n = 1;
            return getSchoolListData();
          case 1:
            _context5.n = 2;
            return getTimeDirectorPeriodData();
          case 2:
            _context5.n = 3;
            return getGradeData();
          case 3:
            getAnalysisData();
            getRecotorData();
            overviewRef.value.getPanelOverview();
          case 4:
            return _context5.a(2);
        }
      }, _callee5);
    })));
    return function (_ctx, _cache) {
      var _component_t_select = _resolveComponent("t-select");
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_Loading = _resolveComponent("Loading");
      var _component_Empty = _resolveComponent("Empty");
      return gradeOptions.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(PageSearch, null, {
        default: _withCtx(function () {
          return [schoolOptions.value.length > 1 ? (_openBlock(), _createBlock(_unref(FormItem), {
            key: 0
          }, {
            formLabel: _withCtx(function () {
              return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode(" 学校 ", -1)]));
            }),
            formInput: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                modelValue: schoolId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return schoolId.value = $event;
                }),
                keys: {
                  label: 'schoolName',
                  value: 'schoolId'
                },
                options: schoolOptions.value,
                onChange: handleChangeSchool
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_unref(FormItem), null, {
            formLabel: _withCtx(function () {
              return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode(" 年级 ", -1)]));
            }),
            formInput: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                modelValue: gradeId.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return gradeId.value = $event;
                }),
                keys: {
                  label: 'name',
                  value: 'id'
                },
                options: gradeOptions.value,
                onChange: handleChange
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          }), _createVNode(_unref(FormItem), null, {
            formLabel: _withCtx(function () {
              return _toConsumableArray(_cache[6] || (_cache[6] = [_createTextVNode(" 类型 ", -1)]));
            }),
            formInput: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                modelValue: cycleType.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return cycleType.value = $event;
                }),
                style: {
                  "width": "100px"
                },
                options: typeOptions.value,
                onChange: handleChangeType
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          }), _createVNode(_unref(FormItem), null, {
            formLabel: _withCtx(function () {
              return _toConsumableArray(_cache[7] || (_cache[7] = [_createTextVNode(" 时间周期 ", -1)]));
            }),
            formInput: _withCtx(function () {
              return [_createVNode(_component_t_select, {
                modelValue: cycle.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return cycle.value = $event;
                }),
                style: {
                  "width": "210px"
                },
                options: timesOptions[cycleType.value],
                onChange: handleChange
              }, null, 8, ["modelValue", "options"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })]), _createVNode(overviewPanel, {
        ref_key: "overviewRef",
        ref: overviewRef,
        class: "mrg16",
        schoolId: schoolId.value,
        cycle: cycle.value,
        gradeId: gradeId.value,
        cycleType: cycleType.value
      }, null, 8, ["schoolId", "cycle", "gradeId", "cycleType"]), _createElementVNode("div", _hoisted_3, [_createVNode(analysisTab, {
        onTabChange: handleAnalyTab
      }), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_svg_icon, {
        class: "svg-class",
        size: 32,
        name: "analy-image"
      }), _cache[8] || (_cache[8] = _createElementVNode("span", null, "按周期", -1))]), states.loading_period ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_Loading)])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [showPeriod.value ? (_openBlock(), _createBlock(_unref(lineAnalysis), {
        key: 0,
        id: "echart",
        data: states.periodData
      }, null, 8, ["data"])) : (_openBlock(), _createBlock(_component_Empty, {
        key: 1,
        "full-height": true,
        icon: _unref(emptyImage)
      }, null, 8, ["icon"]))], 64))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_svg_icon, {
        class: "svg-class",
        size: 32,
        name: "teacher-analy"
      }), _cache[9] || (_cache[9] = _createElementVNode("span", null, "按教师", -1))]), states.loading_teacher ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_Loading)])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [showTeacher.value ? (_openBlock(), _createBlock(_unref(barAnalysis), {
        key: 0,
        id: "echart1",
        data: states.teacherData
      }, null, 8, ["data"])) : (_openBlock(), _createBlock(_component_Empty, {
        key: 1,
        "full-height": true,
        icon: _unref(emptyImage)
      }, null, 8, ["icon"]))], 64))]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_svg_icon, {
        class: "svg-class",
        size: 32,
        name: "class-num"
      }), _cache[10] || (_cache[10] = _createElementVNode("span", null, "按班级", -1))]), states.loading_class ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_Loading)])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [showClass.value ? (_openBlock(), _createBlock(_unref(barAnalysis), {
        key: 0,
        id: "echart2",
        data: states.classData
      }, null, 8, ["data"])) : (_openBlock(), _createBlock(_component_Empty, {
        key: 1,
        "full-height": true,
        icon: _unref(emptyImage)
      }, null, 8, ["icon"]))], 64))])])]), _createElementVNode("div", _hoisted_14, [_createVNode(teachTab, {
        class: "tab-class",
        cycle: cycle.value,
        "school-name": schoolName.value,
        "school-id": schoolId.value,
        gradeId: gradeId.value,
        cycleType: cycleType.value,
        outGradeName: gradeName.value,
        onChangeTab: handleChangeTab
      }, null, 8, ["cycle", "school-name", "school-id", "gradeId", "cycleType", "outGradeName"]), _createVNode(_unref(mTable), {
        class: "mrg16",
        columns: columns.value,
        tdata: tdata.value,
        total: total.value,
        pageSize: size.value,
        current: current.value,
        onChangeCurrent: changeCurrent,
        onChangePageSize: changePageSize
      }, null, 8, ["columns", "tdata", "total", "pageSize", "current"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_Empty, {
        icon: _unref(emptyAllImage),
        "full-height": true
      }, {
        description: _withCtx(function () {
          return _toConsumableArray(_cache[11] || (_cache[11] = [_createElementVNode("div", {
            class: "empty-des"
          }, [_createElementVNode("p", null, "当前尚无年级主任数据权限"), _createElementVNode("p", null, "请找管理员进行应用授权范围设定")], -1)]));
        }),
        _: 1
      }, 8, ["icon"])]));
    };
  }
};